import { ReportTemplate } from 'src/models/ReportTemplate.model';
import { ReportType } from 'src/models/ReportType.model';
import { Session } from 'src/models/Session.model';

import AssurePlusReport from '../reports/AssurePlus/AssurePlusReport';
import OptainReport from '../reports/Optain/OptainReport';

interface IReportRendererProps {
  show: boolean;
  session: Session;
  historyIndex?: number;
  type: ReportType;
  logo: string;
}

const ReportRenderer: React.FC<IReportRendererProps> = ({
  show,
  session,
  historyIndex,
  type,
  logo,
}) => {
  return show ? (
    <>
      {session?.template === ReportTemplate.OPTAIN_SMALL_DR ? (
        <OptainReport session={session} />
      ) : (
        <AssurePlusReport
          session={session}
          type={type}
          logo={logo}
          historyIndex={historyIndex}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default ReportRenderer;
